import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Presse(): ReactElement {
  return (
    <PageShell
      title="Presse"
      intro="Informationen und Materialien für Journalistinnen, Journalisten und Medienpartner."
    >
      <PageSection title="Über Saldify">
        <p>
          Saldify ist eine cloudbasierte Buchhaltungssoftware für Selbstständige,
          Freelancer und kleine Unternehmen. Sie vereint Rechnungen, Belege,
          Banking-Abgleich und Auswertungen in einer DSGVO-konformen Anwendung
          „Made in Germany". Betrieben wird Saldify von CuiveMedia (Berlin).
        </p>
      </PageSection>

      <PageSection title="Pressekontakt">
        <p>
          Für Presseanfragen, Interviews oder Bildmaterial erreichen Sie uns unter{' '}
          <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
            info@saldify.de
          </a>
          . Wir stellen auf Anfrage gerne Logos und weitere Materialien bereit.
        </p>
      </PageSection>
    </PageShell>
  );
}
